export default "__VITE_ASSET__Cus5S8W4__"